import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { Labels } from '@core/constants/labels';
import { PingService } from '@core/services/ping-service/ping-service.service';
@Component({
  selector: 'app-connect-status',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './connect-status.component.html',
  styleUrl: './connect-status.component.scss',
})
export class ConnectStatusComponent implements OnDestroy {
  online = true;

  monitorInterval = 1;

  monitor: any = null;

  labels = Labels.PING_STATUS;

  constructor(private pingService: PingService) {}

  setMonitorInterval() {
    if (this.monitor == null) {
      this.monitor = setInterval(
        () => {
          this.pingService.tenantIsConnected().subscribe((d) => {
            this.online = d;
          });
        },
        this.monitorInterval * 60 * 1000,
      );
    }
  }

  ngOnInit() {
    this.setMonitorInterval();
  }

  ngOnDestroy() {
    if (this.monitor !== null) {
      clearInterval(this.monitor);
      this.monitor = null;
    }
  }
}
